import * as React from 'react';
import * as ReactDOM from 'react-dom';
export var renderComponent = function (component) {
    return document.addEventListener('DOMContentLoaded', function () {
        var container = document.getElementById('page-container');
        if (!container) {
            console.error('No container found for mounting React component.');
            return;
        }
        ReactDOM.render(React.createElement(component), container);
    });
};
